import type { AssignationAutomaticEmailType } from "@daytrip/legacy-enums";
import { Exclude, Expose } from "class-transformer";

import { AutomaticEmail } from "./AutomaticEmail";
import type { Order } from "./Order";

@Exclude()
export class AssignationAutomaticEmail extends AutomaticEmail<AssignationAutomaticEmailType> {
    @Expose()
    public changedPropertiesOriginalValues?: { [K in keyof Order]?: Order[K] };
}
